import { Component } from '@angular/core';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { NonPersistedModalName } from '@shared/models/modal.model';
import { LegalLayoutComponent } from '../legal-layout.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let cookieconsent: any;

@TakeUntilDestroy
@Component({
  selector: 'slotcom-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
  standalone: true,
  imports: [LegalLayoutComponent, ButtonComponent, UpperCasePipe, TranslateModule],
})
export class CookiesComponent {
  protected readonly NonPersistedModalName = NonPersistedModalName;

  openCookiesConfig() {
    cookieconsent.openPreferencesCenter();
  }
}
